export const UPGRADES = {
  WIZARD: {
    name: "Wizard",
    description: "Unlock the Wizard",
    requirements: "Requires Fortress 2.",
    cost: 25,
  },
  GIANT: {
    name: "Giant",
    description: "Unlock the Giant",
    requirements: "Requires Fortress 3.",
    cost: 25,
  },
  KAMIKAZE: {
    name: "Kamikaze",
    description: "Unlock the Kamikaze",
    requirements: "Requires Fortress 3.",
    cost: 25,
  },
  HASTE: {
    name: "Haste",
    description: "Your units start with full stamina",
    cost: 50,
    type: "general",
  },
  HASTE_L2: {
    name: "Haste 2",
    description: "Your units start with their special abilities ready",
    cost: 50,
    type: "general",
    icon: "/haste.png",
    requires: ["HASTE"],
  },
  PUMP: {
    name: "Pump",
    description: "Increases how many units you can build per turn by 1",
    cost: 50,
    type: "general",
    icon: "/pump.png",
  },
  PUMP_L2: {
    name: "Pump 2",
    description:
      "Increases how many units you can build per turn by an additional 1",
    cost: 60,
    type: "general",
    requires: ["PUMP"],
    icon: "/pump.png",
  },
  GREED: {
    name: "Greed",
    description: "Each treasure chest gives you 40 instead of 25 gold.",
    cost: 50,
    type: "general",
  },
  GREED_L2: {
    name: "Greed 2",
    description: "Treasure chests give you 80 instead of 40 gold.",
    cost: 60,
    type: "general",
    requires: ["GREED"],
    icon: "/greed.png",
  },
  // Fortress upgrades
  FORTRESS_2: {
    name: "Fortress 2",
    description:
      "+10 fortress health, +12 income. Unlocks new items, spells and units.",
    requirements: "Requires 2 characters alive.",
    cost: 130,
    type: "fortress",
    healthBonus: 10,
    goldBonus: 12,
  },
  FORTRESS_3: {
    name: "Fortress 3",
    description:
      "Additional +20 health. Additional +25 income. Unlocks new items, spells and units.",
    requirements: "Requires Fortress 2.",
    cost: 120,
    type: "fortress",
    healthBonus: 20,
    goldBonus: 25,
    requires: ["FORTRESS_2"],
  },
  // Spell upgrades
  EARTHQUAKE: {
    name: "Earthquake",
    description: "Remove lots of stamina from target characters",
    cost: 30,
    type: "spell",
  },
  EARTHQUAKE_L2: {
    name: "Earthquake 2",
    description: "Stun two targets (double stun)",
    cost: 50,
    type: "spell",
    requires: ["EARTHQUAKE", "FORTRESS_2"],
    icon: "/spells/earthquake.png",
  },
  EARTHQUAKE_L3: {
    name: "Earthquake 3",
    description: "Stun three targets",
    cost: 75,
    type: "spell",
    requires: ["EARTHQUAKE_L2", "FORTRESS_3"],
    icon: "/spells/earthquake.png",
  },
  RAIN_OF_FIRE: {
    name: "Rain of Fire",
    description: "Deal damage to all enemy units",
    cost: 30,
    type: "spell",
  },
  RAIN_OF_FIRE_L2: {
    name: "Rain of Fire 2",
    description: "Target two characters, +3 damage",
    cost: 50,
    type: "spell",
    requires: ["RAIN_OF_FIRE", "FORTRESS_2"],
    icon: "/spells/rain_of_fire.png",
  },
  RAIN_OF_FIRE_L3: {
    name: "Rain of Fire 3",
    description: "Target three characters, 20 damage",
    cost: 75,
    type: "spell",
    requires: ["RAIN_OF_FIRE_L2", "FORTRESS_3"],
    icon: "/spells/rain_of_fire.png",
  },
  WHIRLWIND: {
    name: "Whirlwind",
    description: "Push all nearby units away",
    cost: 30,
    type: "spell",
  },
  WHIRLWIND_L2: {
    name: "Whirlwind 2",
    description: "Reduced cooldown",
    cost: 50,
    type: "spell",
    requires: ["WHIRLWIND", "FORTRESS_2"],
    icon: "/spells/whirlwind.png",
  },
  WHIRLWIND_L3: {
    name: "Whirlwind 3",
    description: "Choose range between 5-15 inches",
    cost: 75,
    type: "spell",
    requires: ["WHIRLWIND_L2", "FORTRESS_3"],
    icon: "/spells/whirlwind.png",
  },
  BACK_TO_LIFE: {
    name: "Back to Life",
    description:
      "Unlocks the Wizard's Revive special ability. Bring a dead character back to life within 3 rounds.",
    cost: 75,
    type: "general",
    requires: ["FORTRESS_3"],
    icon: "/revive.png",
  },
};

// Helper function to get total fortress bonuses from unlocked upgrades
export function getFortressBonuses(unlockedUpgrades) {
  let totalHealthBonus = 0;
  let totalGoldBonus = 0;

  for (const upgradeKey of unlockedUpgrades) {
    const upgrade = UPGRADES[upgradeKey];
    if (upgrade && upgrade.type === "fortress") {
      totalHealthBonus += upgrade.healthBonus || 0;
      totalGoldBonus += upgrade.goldBonus || 0;
    }
  }

  return { healthBonus: totalHealthBonus, goldBonus: totalGoldBonus };
}
